import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/ProcessSetupSheet/FormView/AssociatedAssets'

export default createChildListViewContainer()(Component)
